import request from 'local_modules/request'
import { constants } from 'helpers'
import { reducers, getState } from 'redux/core'


const setFetching = (isFetching) => reducers.marketplace.adminConfigDaysPage.setFetching(isFetching)

const fetchDates = () => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  // const { marketplace: { layersNavigation: { toolType } } } = getState()

  // return request.get(prefix.dates + `/${toolType}?all=true`)
  return request.get(prefix.dates)
    .then(({ data }) => data)
    .then((dates) => {
      reducers.marketplace.adminConfigDaysPage.setDates(dates)
    })
    .catch((error) => {
      console.log(error)
    })
}

const setDates = (dates) => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  // const { marketplace: { layersNavigation: { toolType } } } = getState()

  // return request.post(prefix.dates + `/${toolType}?all=true`, dates)
  return request.post(prefix.dates, dates)
    .then(({ data }) => data)
    .catch((error) => {
      console.log(error)
    })
}


export default {
  setFetching,
  fetchDates,
  setDates,
}
